import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import createHashHistory from 'history/lib/createHashHistory'
import configureStore from './store/configureStore'

import './antd.css'
import './index.less'
import './lib/sugar'
import registerServiceWorker from './lib/registerServiceWorker'

import { Router, Route } from 'react-router';

import { 
  Messages, 
  Watch, 
  Subscriptions, 
  Search, 
  AdminConfiguration, 
  PastEvents, 
  Channels,
  ChannelPage,
  EventEditor,
  AuthPage,
  MyProfile,
  ProfileInfo,
  Payments,
  SavedEvents,
  Root
} from './pages';

const historyHash = createHashHistory({ alwaysEnableState: true });
const { store, history } = configureStore(historyHash);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route exact name="Root" path="/root" component={Root}>
        <Route path="/" component={Channels} />
        <Route path="/profile" component={MyProfile} />
        <Route path="/profile/:profileId" component={ProfileInfo} />
        <Route path="/Payments" component={Payments} />

        <Route path="/Auth" component={AuthPage} />

        <Route path="/Channels" component={Channels} />
        <Route path="/Channels/:channelId" component={ChannelPage} />
        <Route path="/Event_Editor" component={EventEditor} />
        <Route path="/Event_Editor/:eventId" component={EventEditor} />

        <Route path="/Saved_events" component={SavedEvents} />
        <Route path="/Messages/:id" component={Messages} />
        <Route path="/Messages" component={Messages} />
        <Route path="/Subscriptions" component={Subscriptions} />

        <Route path="/Past_Events/:type" component={PastEvents} />
        <Route path="/watch/:id" component={Watch} />

        <Route path="/Admin_configuration/:key" component={AdminConfiguration} />

        <Route path="/Search" component={Search} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js